import React, { useEffect } from 'react';
import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export let getShelvesMachine: any;

export const useSMGetShelves = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  getShelvesMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(getShelvesMachine);

  useEffect(() => {
    send({ type: 'START' });
  }, []);

  return {
    getShelvesMachine,
    getShelvesMachineState: state,
    getShelvesMachineSend: send,
  };
};
